// Breakpoints para diseño responsive
export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1366px',
  large: '1920px',
};

// Media queries helpers
export const MEDIA_QUERIES = {
  mobile: `@media (max-width: ${BREAKPOINTS.mobile})`,
  tablet: `@media (max-width: ${BREAKPOINTS.tablet})`,
  desktop: `@media (min-width: ${BREAKPOINTS.desktop})`,
  large: `@media (min-width: ${BREAKPOINTS.large})`,

  // Rangos específicos
  mobileOnly: `@media (max-width: ${BREAKPOINTS.mobile})`,
  tabletOnly: `@media (min-width: ${BREAKPOINTS.mobile}) and (max-width: ${BREAKPOINTS.tablet})`,
  desktopUp: `@media (min-width: ${BREAKPOINTS.tablet})`,
};

export default BREAKPOINTS;
